import styled, { keyframes } from "styled-components";

const dashAnimation = keyframes`
  0% {
    stroke-dasharray: 1, 95;
    stroke-dashoffset: 0;
  }
  50% {
    stroke-dasharray: 85, 95;
    stroke-dashoffset: -25;
  }
  100% {
    stroke-dasharray: 85, 95;
    stroke-dashoffset: -93;
  }
`;

const rotateAnimation = keyframes`
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
`;

const ImageUploadCategoriaContainer = styled.div`
    width: 13rem;
    height: 13rem;
    min-width: 13rem;

    .logo-input-container-empresa {
        width: 100%;
        height: 100%;

        .logo-wrapper {
            width: 100%;
            height: 100%;
            cursor: pointer;
            display: flex;
            align-items: center;
            overflow: hidden;
            justify-content: center;
            border-radius: 100%;
            background-color: ${(props) => props.theme.colors.white};

            svg {
                fill: ${(props) => props.theme.colors.tertiary};
            }

            img {
                width: 100%;
                height: 100%;
            }
        }
    }
    .disabled-input {
        pointer-events: none;
        cursor: not-allowed;
    }
`;

const ModalCroppingContainer = styled.div`
  width: 65rem;
  max-width: 100%;
  padding: 0 2rem;
  .titulo {
    color: ${(props) => props.theme.colors.tertiary};
    text-align: left;
    padding: 2rem 0 0 2rem;
    font-weight: bold;
  }
  .botoes {
    display: flex;
    width: 100%;
    justify-content: space-between;
    align-items: center;
    padding: 2rem 0 0 2rem;
    .cancelar {
      cursor: pointer;
      margin-top: 0 !important;
      color: ${(props) => props.theme.colors.tertiary};
    }
  }
`;

export { ImageUploadCategoriaContainer, ModalCroppingContainer };
